import { Helmet } from 'react-helmet-async';

interface VenueSchema {
  name: string;
  description?: string;
  streetAddress: string;
  city: string;
  postalCode?: string;
  country: string;
  latitude?: number;
  longitude?: number;
  phone?: string;
  url?: string;
  image?: string;
}

const DEFAULT_VENUES: VenueSchema[] = [
  {
    name: 'Relais de Dranse – Nomad Fest Venue',
    description: 'Main venue for Nomad Fest events. A lakeside retreat center in the Swiss Alps, hosting festivals, retreats, and academies for digital nomads.',
    streetAddress: 'Route de la Dranse',
    city: 'Thonon-les-Bains',
    postalCode: '74200',
    country: 'FR',
    latitude: 46.3697,
    longitude: 6.4783,
    url: 'https://nomadfest.io',
    image: 'https://nomad-fest-com.lovable.app/og-default.png',
  },
];

interface LocalBusinessSchemaProps {
  venues?: VenueSchema[];
}

export function LocalBusinessSchema({ venues = DEFAULT_VENUES }: LocalBusinessSchemaProps) {
  const jsonLd = venues.map((venue) => ({
    '@context': 'https://schema.org',
    '@type': 'EventVenue',
    name: venue.name,
    description: venue.description,
    image: venue.image,
    url: venue.url,
    address: {
      '@type': 'PostalAddress',
      streetAddress: venue.streetAddress,
      addressLocality: venue.city,
      postalCode: venue.postalCode,
      addressCountry: venue.country,
    },
    ...(venue.latitude && venue.longitude
      ? {
          geo: {
            '@type': 'GeoCoordinates',
            latitude: venue.latitude,
            longitude: venue.longitude,
          },
        }
      : {}),
    ...(venue.phone ? { telephone: venue.phone } : {}),
  }));

  return (
    <Helmet>
      {jsonLd.map((schema, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
}
